import React from 'react';
import './ModernCard.scss';
import Card from '../../Common/Card/Card';

const CustomCard = ({ heading, subheading, icon, className, ...props }) => {
    return (
        <Card className={`ModernCard ${className}`} {...props}>
            <div className="header header-flex">
                <h4 className="heading">{heading}</h4>
                <div className="subheading-container">
                    <div className="subheading-wrapper">
                        <p className="subheading">{subheading}</p>
                    </div>
                    <div className="icon1">{icon}</div>
                </div>
            </div>
        </Card>
    );
};

export default CustomCard;
